module.exports = __webpack_public_path__ + "static/media/address.23dc5f02.svg";